<template>
  <donut-slack-preview :hide-name="true" :message="message" />
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();
  const props = defineProps({
    points: { type: Number, required: true },
  });

  const config = computed(() => state.pointsConfig.config);
  const message = computed(() => {
    const pointsName = props.points === 1 ? config.value.points_name : config.value.points_name_plural;
    const oneEmoji = `:${config.value.emoji}:`;
    const emojis = (props.points >= 1 && props.points <= 5) ? oneEmoji.repeat(props.points) : oneEmoji;
    const pointsText = `${props.points} ${pointsName} ${emojis}`;

    const verb = props.points === 1 ? 'is' : 'are';
    const baseMessage = `Here ${verb} ${pointsText} as a token of appreciation for attending your Donut Intro and connecting with your team!`;

    if (config.value.active_rewards_program) {
      return `${baseMessage} ${oneEmoji}'s can be redeemed in the ${$i18n.t('shoutouts.rewards_store').toLowerCase()}.`;
    }
    return baseMessage;
  });
</script>
